import { render, staticRenderFns } from "./ExamineBigData.vue?vue&type=template&id=d72d70e4&scoped=true"
import script from "./ExamineBigData.vue?vue&type=script&lang=js"
export * from "./ExamineBigData.vue?vue&type=script&lang=js"
import style0 from "./ExamineBigData.vue?vue&type=style&index=0&id=d72d70e4&prod&lang=scss&scoped=true"
import style1 from "./ExamineBigData.vue?vue&type=style&index=1&id=d72d70e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72d70e4",
  null
  
)

export default component.exports